import React, { useState, useEffect, useRef } from "react";

import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { useConfig } from "./ConfigContext";

export default function NutzergrafikV2H({ availableUsers, heading, users, estates, setSelectedUser, statConfig }) {
   const [graphData, setGraphData] = useState();
   const config = useConfig();

   useEffect(() => {
      let userdata = structuredClone(availableUsers);

      if (estates && users) {
         estates.forEach((item) => {
            let itemuser = item.benutzer;
            if (!userdata[itemuser]) {
               userdata[itemuser] = Object.keys(statConfig.aktuell).reduce(
                  (oldObj, item) => ({ ...oldObj, [item]: [] }),
                  {},
               );
            }
            if (userdata[itemuser][item.status2]) userdata[itemuser][item.status2].push(item);
         });
         setGraphData(
            Object.keys(userdata).map((item) => {
               return {
                  ["name"]: users[item] ? users[item].Kuerzel : item,
                  ...Object.keys(statConfig.aktuell).reduce(
                     (oldObj, keyItem) => ({
                        ...oldObj,
                        [statConfig.aktuell[keyItem]]: userdata[item][keyItem] ? userdata[item][keyItem].length : 0,
                     }),
                     {},
                  ),
                  ["data"]: userdata[item],
                  ["userId"]: item,
               };
            }),
         );
      }
   }, [estates, users]);

   function renderCustomBarLabel({ payload, x, y, width, height, value, altLabel, isCurrency }) {
      return (
         <text x={x + width / 2} dx={0} y={y} fill="#fff" fontWeight={500} fontSize={20} textAnchor="middle" dy={-10}>
            {isCurrency ? (
               <tspan textAnchor="middle">
                  {new Intl.NumberFormat("de-DE", {
                     style: "currency",
                     currency: "EUR",
                     maximumFractionDigits: 0,
                  }).format(value)}
               </tspan>
            ) : (
               <tspan textAnchor="middle">{value ? value : ""}</tspan>
            )}
            {altLabel && (
               // <tspan textAnchor="middle" x={x + width / 2} y={y - 24}>
               <tspan textAnchor="middle" x={x + width / 2} y={y - 24}>
                  {altLabel}
               </tspan>
            )}
         </text>
      );
   }

   function CustomTooltip({ active, payload, label }) {
      const isVisible = active && payload && payload.length;
      if (isVisible) {
      }

      return (
         <div
            style={{
               visibility: isVisible ? "visible" : "hidden",
               backgroundColor: "#fffe",
               borderRadius: "10px",
               color: "#000",
               padding: "10px",
               margin: "0 40px",
               boxShadow: "0 0 20px 2px #000",
               maxHeight: 200,
            }}
         >
            {isVisible && (
               <>
                  <p className="label">
                     {users[payload[0].payload.userId]
                        ? users[payload[0].payload.userId].Name
                        : users[payload[0].payload.userId]
                          ? users[payload[0].payload.userId]
                          : payload[0].payload.userId}
                  </p>
                  <div>
                     <div style={{ display: "flex", flexDirection: "row" }}>
                        {Object.keys(payload[0].payload.data).map((item) => (
                           <div className="mx-1" key={"key_" + item}>
                              {statConfig.aktuell[item]}
                              <div
                                 style={{
                                    maxWidth: 160,
                                    fontSize: 14,
                                    wordBreak: "break-word"
                                 }}
                              >
                                 {payload[0].payload.data[item].map((item2) => item2.objektnr_extern).join(", ")}
                              </div>
                           </div>
                        ))}
                     </div>
                  </div>
               </>
            )}
         </div>
      );
   }

   return (
      <div
         style={{
            width: "100%",
            position: "absolute",
            left: 0,
            top: 800,
            overflow: "hidden",
         }}
      >
         <div
            style={{
               // position: "absolute",

               width: "100%",
               zIndex: 100,
            }}
         >
            <div
               style={{
                  top: -6,
                  zIndex: 101,
                  backgroundColor: "#0006",
                  backdropFilter: "blur(4px)",
                  margin: 0,
                  padding: "10px 0px",
                  position: "sticky",
                  width: "100%",
                  textAlign: "center",
               }}
            >
               <h2 className="mb-3">{heading}</h2>
               {Object.keys(statConfig.aktuell).map((item) => (
                  <span
                     style={{
                        padding: "2px 10px",
                        margin: "0px 10px",
                        border: "solid 6px " + config.verkaufsStatusFarben?.[item]?.color,
                        fontWeight: 600,
                        background: config.verkaufsStatusFarben?.[item]?.color + "33",
                     }}
                  >
                     {config.verkaufsStatusFarben?.[item]?.name}
                  </span>
               ))}
            </div>
            {graphData && (
               <div>
                  <ResponsiveContainer
                     style={{ background: "linear-gradient(180deg, #0004 0%, #0000 100%)" }}
                     width={"100%"}
                     height={300}
                  >
                     <BarChart
                        barSize={22}
                        // barGap={10}
                        data={graphData}
                        // layout="vertical"
                        margin={{
                           top: 50,
                           right: 0,
                           left: 0,
                           bottom: 0,
                        }}
                        onClick={(e) => {
                           setSelectedUser(e.activePayload[0].payload.userId);
                           console.log(e.activePayload[0].payload.userId);
                        }}
                     >
                        <XAxis dataKey="name" type="category" tick={{ fill: "#eef", fontSize: "normal" }} />
                        <YAxis type="number" tick={{ fill: "#eef", fontSize: "small" }} hide />
                        <Tooltip
                           cursor={false}
                           isAnimationActive={false}
                           // position={{ y: 0, dx: 50 }}
                           content={CustomTooltip}
                        />
                        {Object.keys(statConfig.aktuell).map((item) => (
                           <Bar
                              key={"key_" + item}
                              dataKey={config.verkaufsStatusFarben[item] ? config.verkaufsStatusFarben[item].name : ""}
                              fill={
                                 config.verkaufsStatusFarben[item] ? config.verkaufsStatusFarben[item].color : "#40f"
                              }
                              /* stroke={
                                 config.verkaufsStatusFarben[item] ? config.verkaufsStatusFarben[item].color : "#40f"
                              }
                              strokeWidth={3} */
                              label={renderCustomBarLabel}
                              onClick={(e) => {
                                 const { payload } = e;
                                 console.log(payload);
                              }}
                           />
                        ))}
                     </BarChart>
                  </ResponsiveContainer>
               </div>
            )}
         </div>
      </div>
   );
}
